module.exports = __webpack_public_path__ + "static/media/student2.ec35f378.png";